// Customer profile → Bookings (F-RSV-N1): the guest's reservation history
// and how many times they didn't turn up.
import { useQuery } from '@tanstack/react-query'
import apiClient from '@/api/client'
import { Badge } from '@/components/ui/badge'
import { STATUS_LABEL, SOURCE_LABEL, pktDate, pktTime } from '@/lib/reservations'

export function CustomerReservationsPanel({ customerID }: { customerID: string }) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['reservations', 'customer', customerID],
    queryFn: () => apiClient.getCustomerReservations(customerID).then((r) => r.data),
  })
  if (isLoading) return <p className="text-sm text-muted-foreground">Loading…</p>
  if (isError || !data) return <p className="text-sm text-muted-foreground">Could not load bookings.</p>
  const list = data.reservations
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-6 text-sm">
        <div>
          <p className="text-muted-foreground">Bookings</p>
          <p className="text-lg font-semibold tabular-nums">{data.total}</p>
        </div>
        <div>
          <p className="text-muted-foreground">No-shows</p>
          <p className={`text-lg font-semibold tabular-nums ${data.no_show_count > 0 ? 'text-destructive' : ''}`}>
            {data.no_show_count}
          </p>
        </div>
      </div>
      {list.length === 0 ? (
        <p className="text-sm text-muted-foreground">No table bookings yet.</p>
      ) : (
        <div className="divide-y rounded-lg border">
          {list.map((r) => (
            <div key={r.id} className="flex flex-wrap items-center justify-between gap-2 px-4 py-2 text-sm">
              <span>
                {pktDate(r.starts_at)} · {pktTime(r.starts_at)}
                <span className="text-muted-foreground">
                  {' '}
                  · {r.party_size} guests{r.tables.length ? ` · ${r.tables.map((t) => t.table_number).join(' + ')}` : ''} ·{' '}
                  {SOURCE_LABEL[r.source]}
                </span>
              </span>
              <Badge variant={r.status === 'no_show' ? 'danger-surface' : 'neutral-surface'}>{STATUS_LABEL[r.status]}</Badge>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
